import { createFileRoute, redirect } from "@tanstack/react-router";
import { splitSlug } from "@/lib/utils";

export const Route = createFileRoute("/artikel/$slug")({
  loader: async ({ params }) => {
    const { id, slug } = splitSlug(params.slug);
    if (id && slug) {
      throw redirect({
        to: "/artikel/$id/$slug",
        params: { id, slug },
      });
    }
  },
});
